export const HUBSPOT_FORM_CONFIG = {
  HUBSPOT_ID: '2799205',
  FORM_URL: 'https://api.hsforms.com/submissions/v3/integration/submit',
  NEWSLETTER: {
    GUID: 'dde7f579-de7b-4e02-b281-6e212bcfb44d',
  },
  RESELLERS: {
    GUID: '7baffab9-98ca-47f2-8a3d-a301e7327daf',
  },
  DEMO: {
    GUID: 'b8b0af8d-e593-4995-b4c1-bb420b17e2ad',
  },
};
